import { useState, useEffect } from "react";
import {Typography, Modal, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';

import SectionSpinner from "../Loading/SectionSpinner/SectionSpinner";

import IconGear from '../../assets/svgs/gear.svg';

import './SettingsModal.css';


const modal_style = {
  position: 'absolute',
  top: '20px',
  left: '50%',
  transform: 'translate(-50%, 0px)',
  width: '60vw',
  bgcolor: 'rgba(255,255,255,0.05)',
  backdropFilter: 'blur(20px)',
  borderRadius: '5px',
  boxShadow: '0px 20px 50px #00000029',
  p: 4,
};


function SettingsModal(props) {

    const [open, setOpen] = useState(false);
    

    
    const [lockForm, setLockForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({message:'', firstName:false, lastName:false, email:false, twitter:false});


    function handleOpen(){
        setOpen(true);
    }

    function handleClose(){
        // Prevent closing when we are awaiting a reply.
        if(!lockForm){
            setOpen(false);
        }
    }

    function ignoreThisChange(device_id, label){
        //console.log("Device ID: "+device_id+"'s label is now: "+label);
    }

    async function handleLabelChange(device_id, label){
        console.log("Device ID: "+device_id+"'s label is now: "+label);

        // Submit the data to the server.
        // Change the submit button to a spinner and lock form inputs
        setLoading(true);
        setLockForm(true);

        return fetch(process.env.REACT_APP_API_ENDPOINT+'squadslive/label', {
            method: 'POST',
            headers: {
                'Authorization': localStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({deviceId: device_id, label: label})
        })
        .then(res => res.json())
        .then(function (response){    
            if(response.code === 200){
                
                props.updateDevices(response);

                setLoading(false);
                setLockForm(false);
                return true;

            }else{
                console.log("An error occured processing the data.");
                alert("There was an error updating the ")
                setLoading(false);
                setLockForm(false);
                return false;
            }        
        })


    }

    useEffect(() => {
        console.log(errors);
    },[errors]);

    if(props.loadingState){
        return (
            <></>
        )
    }
    else{
        return (
        <div>

            <img src={IconGear} alt='Settings' id="common-nav-settings" onClick={handleOpen}/>

            <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <Box sx={modal_style} className="rezzil-shine">
                <Typography id="modal-modal-title" variant="h6" component="h2" sx={{color:"#ffffff", mb:2}}>
                    System Settings
                </Typography>

                
                <TableContainer>
                    <Table sx={{ minWidth: 650 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Serial Number</TableCell>
                                <TableCell>Label</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {props.devices.map((row) => (
                            <TableRow
                            key={row.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                            <TableCell component="th" scope="row">
                                {row.id}
                            </TableCell>
                            <TableCell>{row.device_serial}</TableCell>
                            <TableCell>
                                <input type="text" defaultValue={row.label} onChange={event => ignoreThisChange(row.device_serial, event.target.value)} onBlur={event => handleLabelChange(row.device_serial, event.target.value)}/>
                            </TableCell>
                            </TableRow>
                        ))}
                        </TableBody>
                    </Table>
                </TableContainer>



                {
                    loading &&
                    <SectionSpinner/>
                }
                

                
            </Box>
            </Modal>
        </div>
        );
    }
    
  }
  

  export default SettingsModal;